// @ts-nocheck
import { GetReportOrderFrequencyApiParameter } from "@store/Framework/Types/types";
import { useDispatch } from "react-redux";

const useUpdateSearchFields = () => {
    const dispatch = useDispatch();
    return (params: GetReportOrderFrequencyApiParameter) =>
        dispatch({
            type: "Store/Pages/ReportOrderFrequency/UpdateReportSearchFields",
            parameter: params,
        });
};

export default useUpdateSearchFields;
